import $ from "jquery";
import _ from "lodash";
import { EventEmitter } from "../events/eventEmitter";
import { subscribe } from "../events/jQuerySubscription";
import { errorClass } from "../ajax/validation";
import { dialogs } from "./dialogs";
import Sortable from "sortablejs";
export class Cloneable extends EventEmitter {
    constructor(props) {
        const { scope = document, canAddItem: canAddItem = () => true, canRemoveItem = () => true, addSelector, removeSelector, resetFieldsOnClone = true, autoScroll = true, } = props;
        super();
        this.subscriptions = [];
        this.container = props.container;
        this.itemSelector = props.itemSelector;
        this.lastItemOptions = props.lastItemOptions;
        this.indexOptions = props.indexOptions;
        this.resetFieldsOnClone = resetFieldsOnClone;
        this.autoScroll = autoScroll;
        if (props.draggableHandleSelector) {
            $(props.draggableHandleSelector).on("click", (e) => e.preventDefault());
            let sortableElement = $(this.container);
            if (sortableElement.is("table"))
                sortableElement = $(this.container).children("tbody");
            this.sortable = Sortable.create(sortableElement[0], {
                handle: props.draggableHandleSelector,
                animation: 150,
                onEnd: () => {
                    this.resetNamesAndIds();
                    this.emit("itemDragged");
                },
            });
        }
        removeSelector &&
            this.subscriptions.push(subscribe($(scope), "click", removeSelector, async (e) => {
                const item = $(e.target).parents(this.itemSelector)[0];
                if (this.canRemoveItem() && (await canRemoveItem(item))) {
                    this.removeItem(item);
                }
            }));
        addSelector &&
            this.subscriptions.push(subscribe($(scope), "click", addSelector, () => canAddItem() && this.addItem()));
    }
    addItem(options = { focus: true }) {
        const newItem = $(this.container).find(this.itemSelector).first().clone();
        if (this.resetFieldsOnClone) {
            newItem.find("input").not(".custom-field-metadata").val("");
            newItem.find("select option").removeAttr("selected");
        }
        newItem.find(`.${errorClass}`).removeClass(errorClass);
        newItem.appendTo(this.container);
        this.autoScroll &&
            newItem[0].scrollIntoView({
                block: "nearest",
                inline: "nearest",
                behavior: "smooth",
            });
        options.focus &&
            setTimeout(() => newItem
                .find(".form-control")
                .first()
                .find("input[type='text']:not([data-date-picker-input])")
                .trigger("focus"), 100);
        this.resetNamesAndIds();
        this.emit("itemAdded", newItem[0]);
        return newItem;
    }
    removeItem(item) {
        $(item).remove();
        this.resetNamesAndIds();
        this.emit("itemRemoved", item);
    }
    canRemoveItem() {
        const numberOfItems = $(this.container).find(this.itemSelector).length;
        if (numberOfItems > 1 || !this.lastItemOptions)
            return true;
        dialogs.showDialog("alert", this.lastItemOptions);
        return false;
    }
    cleanUp() {
        var _a;
        this.subscriptions.forEach((s) => s.off());
        (_a = this.sortable) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    resetNamesAndIds() {
        $(this.container)
            .find(this.itemSelector)
            .toArray()
            .forEach((item, index) => {
            $(item)
                .find("input, select")
                .toArray()
                .forEach((i) => {
                const input = $(i);
                const currentName = input.prop("name");
                const currentId = input.prop("id");
                currentName &&
                    input.prop("name", currentName.replace(/\[(.*?)\]/, `[${index}]`));
                currentId &&
                    input.prop("id", currentId.replace(/\_(.*?)\_/, `_${index}_`));
            });
            if (this.indexOptions) {
                $(item)
                    .find(this.indexOptions.indexSelector)
                    .text(this.indexOptions.indexGenerator(index + 1));
            }
        });
    }
}
class CloneableFactory extends EventEmitter {
    constructor() {
        super(...arguments);
        this.cloneables = [];
    }
    make(props) {
        const cloneable = new Cloneable(props);
        const subscriptions = [
            cloneable.on("itemAdded", (i) => this.emit("itemAdded", i)),
            cloneable.on("itemRemoved", (i) => this.emit("itemRemoved", i)),
            cloneable.on("itemDragged", () => this.emit("itemDragged")),
        ];
        this.cloneables.push({
            cloneable: cloneable,
            destroy: () => {
                cloneable.cleanUp();
                subscriptions.forEach((s) => s.off());
            },
        });
        return cloneable;
    }
    destroy(cloneable) {
        _.remove(this.cloneables, (e) => e.cloneable === cloneable).forEach((e) => e.destroy());
    }
}
export const cloneableFactory = new CloneableFactory();
